import '@/modules/product-variants';
import '@/modules/product-modal';

import ProductForm from '@/modules/product-form';
import FreeDeliveryBanner from '@/modules/free-delivery-banner';
import PdpMediaGallery from '@/modules/media-gallery';
import { QuantityInput } from '@/modules/cart';
import ProductCTASticky from '@/modules/product-cta-sticky';
import ProductIngredientsCarousel from '@/modules/product-ingredients-carousel/index';
import VariantDropdown from '@/modules/variant-dropdown';

if (document.getElementsByTagName('product-form')) {
    if(!customElements.get('product-form')) {
        customElements.define('product-form', ProductForm);
    }
}

if (document.getElementsByTagName('free-delivery-banner')) {
    if(!customElements.get('free-delivery-banner')) {
        customElements.define('free-delivery-banner', FreeDeliveryBanner);
    }
}

if (document.getElementsByTagName('quantity-input')) {
    if(!customElements.get('quantity-input')) {
        customElements.define('quantity-input', QuantityInput);
    }
}

if (document.querySelector('.js-pdp-media-gallery')) {
    new PdpMediaGallery(document.querySelector('.js-pdp-media-gallery'));
}

if (document.querySelector('.js-pdp-cta-sticky')) {
    new ProductCTASticky(document.querySelector('.js-pdp-cta-sticky'));
}

if (document.querySelector('.js-pdp-ingredients-carousel')) {
    new ProductIngredientsCarousel(document.querySelector('.js-pdp-ingredients-carousel'));
}

document.querySelectorAll('.js-variant-dropdown-pdp').forEach((container) => {
    new VariantDropdown(container);
});
